import { LearningProgressReportPage } from "@/features/learning-progress/pages/LearningProgressReport";

export default LearningProgressReportPage;
